import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

export const LANGUAGES = [
    { value: 'en', label: 'English' },
    { value: 'zh', label: '中文' },
    { value: 'bn', label: 'বাংলা' },
    { value: 'th', label: 'ไทย' }
];

// Every `locales/<lang>.json` under src/ (core, modules, templates) is merged.
// Each file owns its top-level namespaces, e.g. { "deposit": { ... } }.
const context = require.context('@/', true, /\/locales\/[a-z]{2}\.json$/);

const messages = context.keys()
    .filter(key => key.startsWith('./'))
    .reduce((acc, key) => {
        const lang = key.match(/([a-z]{2})\.json$/)[1];
        acc[lang] = { ...acc[lang], ...context(key) };
        return acc;
    }, {});

const storedLang = localStorage.getItem('lan');
const initialLang = LANGUAGES.some(l => l.value === storedLang) ? storedLang : 'en';
if (storedLang !== initialLang) localStorage.setItem('lan', initialLang);

const i18n = new VueI18n({
    locale: initialLang,
    fallbackLocale: 'en',
    messages
});

// Menu / category label: `sidebar.<key>` translation (current or fallback
// locale), otherwise the key in title case ("LIVEGRAND" → "Livegrand").
export function categoryLabel(key) {
    if (!key) return '';
    const path = 'sidebar.' + key.toLowerCase();
    if (i18n.te(path) || i18n.te(path, i18n.fallbackLocale)) return i18n.t(path);
    return key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();
}

export default i18n;
